import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
export default new (class RecipesCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-recipes"
        this.sliderProductContainerSelector = "carousel-recipes-product"
        this.sliderNextSelector = "carousel-recipes-next"
        this.sliderPrevSelector = "carousel-recipes-prev"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.${this.sliderContainerSelector}:not(.carousel-main-recipe)`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                nested: true,
                allowTouchMove: false,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 1.05,
                        spaceBetween: 16,
                    },
                    1280: {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    },
                    1641: {
                        slidesPerView: 1,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.${this.sliderProductContainerSelector}`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 2.13,
                spaceBetween: 4,
                centerInsufficientSlides: true,
            })
        })
    }
})()
